const ShimmerAmination = () => {
  return (
    <style>{`
            .overall-performance::before {
              content: '';
              position: absolute;
              top: -50%;
              left: -50%;
              width: 200%;
              height: 200%;
              background: radial-gradient(
                circle,
                rgba(255, 255, 255, 0.1) 0%,
                transparent 70%
              );
              animation: shimmer 3s ease-in-out infinite;
            }
    
            @keyframes shimmer {
              0%,
              100% {
                transform: rotate(0deg);
              }
              50% {
                transform: rotate(180deg);
              }
            }
          `}</style>
  );
};

export default ShimmerAmination;
